import React from 'react'

const Robotics = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Process Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>Robotics</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/robotics.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Robotics:</h2>
                        <p className="mbot25">
                            Our robotics solutions bring automation to the forefront
                            of your operations. We offer robots that perform tasks with high
                            precision and efficiency,
                            from manufacturing and assembly to packaging and beyond.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Robotics
